/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForServiceNow extends models.GovernanceConfigurationBaseForItsm {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForServiceNow.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForServiceNow>): GovernanceConfigurationBaseForServiceNow {
        let obj = Object.assign(new GovernanceConfigurationBaseForServiceNow(), model);
        GovernanceConfigurationBaseForServiceNow.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForServiceNow>): GovernanceConfigurationBaseForServiceNow {
        if (!model) return null;
        return GovernanceConfigurationBaseForServiceNow.newInstance(<GovernanceConfigurationBaseForServiceNow> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForServiceNow) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForServiceNow.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForServiceNow): boolean {
        if (models.GovernanceConfigurationBaseForItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForServiceNow.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
